export const dreamjobs_txt = {
  description: 'Somos una empresa del portafolio de Telefónica Open Future. DreamJobs se ha consolidado como la plataforma tecnológica de reclutamiento, administración, evaluación y contratación de personal más importante de Colombia, brindando un servicio garantizado a través de la experiencia y el amplio conocimiento de los sectores económicos.',
  banner_main: '',
  name: 'Dreamjobs',
  banner_sub: 'Empresas y colaboradores más cerca',
  company: 'all' 
};

export const dreamjobspro_txt = {
  description: 'Reconocidos en el mercado como la empresa de selección de personal con mayor crecimiento en Colombia, hemos descubierto que no existen recetas prediseñadas, por eso nuestro enfoque se basa en un método constructivo entre los valores y la cultura de las empresas clientes, por esta razón, transformamos el concepto ‘selección’ en un verdadero método de integración, donde constantemente estamos implementando mejoras en la herramienta en pro de las empresas que quieren ahorrar costos y disminuir tiempo e incertidumbre a la hora de contratar colaboradores.',
  banner_main: '',
  name: 'Dreamjobs',
  banner_sub: 'Somos tu área de selección de personal ',
  banner_sub2: '',
  company: 'f97dcfb8-0c59-11e7-9285-0a27dd8e0575' 
};

export const espectador_txt = {
  description: 'En El Espectador entendemos lo importante que es la información para usted y seguimos siendo testigos del movimiento social de todas las generaciones que nos leen. Hoy, inmersos en el mundo digital, queremos seguir apostándole al poder de innovación y por eso, en una alianza con DreamJobs, la plataforma que le ayuda a alcanzar sus metas profesionales, queremos que la búsqueda de empleo sea eficiente y rápida en tiempos de cuarta revolución industrial. Con tan solo un clic usted es el verdadero protagonista del valor de la información.',
  banner_main: 'El Espectador',
  name: 'El Espectador',
  banner_sub: 'te acerca al empleo de tus sueños',
  banner_sub2: 'El Valor de la información',
  company: 'all'
};

export const activos_txt = {
  description: 'ACTIVOS fue constituida como Sociedad, el 14 de abril de 1983; producto de la iniciativa de varios ejecutivos con amplia trayectoria en el sector empresarial colombiano y vinculados a la industria del país. Características estas que les permitió crear una organización dedicada a la asesoría y a la solución de todas las necesidades en la Administración del Talento Humano. Desde abril de 1983 Activos se comprometió con COLOMBIA, generando fuentes de empleo para mejorar la calidad de vida y el bienestar de los Colombianos. ACTIVOS  dispone de toda su capacidad financiera, técnica y administrativa, con el objetivo de brindar un servicio especializado, ágil y oportuno.',
  banner_main: 'Activos S.A.S.',
  name: 'Activos S.A.S.',
  banner_sub: 'El talento humano es nuestro mejor recurso',
  banner_sub2: 'Líderes a nivel Nacional en la Administración Integral del Talento Humano',
  company: 'f97dcfb8-0c59-11e7-9285-0a27dd8e0575'
};

export const txt_hv = {
  
  titulo_features:"Portal de Empresas",

  menu_inicio:" ",

  menu_des_nos:"Descripción",

  menu_portal:"Portal de Empresas",

  titulo_urlempresa:"Registrar Tu Empresa Gratis", 
  
  urlempresa:"https://dreamjobs.com.co/DJ/empresa",

  titulo_chatbots:'Chatbots',
  chatbots:'A través de nuestros sofisticados Chatbots evalúa cientos de candidatos al tiempo evitando miles de horas de llamadas.',
  
  titulo_kanban:'kanban',
  kanban:'Visualiza mejor tu flujo de trabajo con nuestro Kanban Inteligente y crea nuevos estados según tus procesos y método de trabajo.',
  
  titulo_BD:'Base de Datos',
  BD:'Invita candidatos a tus ofertas laborales buscando perfiles en nuestra Base de Datos de más de 700.000 hojas de vida.',
  
  titulo_GD:'Gestor Documental',
  GD:'Solicita documentación relacionada a la oferta con nuestro Gestor Documental, los candidatos pueden adjuntar los archivos requeridos ¡Cuidemos juntos el medio ambiente!',
  
  titulo_FC:'Formulario Por Competencias',
  FC:'Evalúa habilidades blandas de tus candidatos con nuestro formulario por competencias.',
  
  titulo_PC:'Pots Contratacion',
  PC:'Evalúa los objetivos e indicadores de tus empleados a través de un modelo bilateral de evaluación inteligente basados en un método constructivo.',
};

export const txt_hv1 = {
  
  titulo_features:"Nuestro Proceso",
  
  menu_des_nos:"Descripción",

  menu_portal:"Nuestro Proceso",

  titulo_urlempresa:"Registrar Tu Empresa Gratis", 
  
  urlempresa:"https://dreamjobs.com.co/DJ/empresa",

  titulo_chatbots:'Levantamiento del cargo',
  chatbots:'Es el primer paso para conocer las necesidades del cliente y así mismo identificar las características que se requieren para la vacante solicitada.',
  
  titulo_kanban:'Cronograma de actividades',
  kanban:'Se realiza el envío de cronograma de actividades donde nuestro cliente conoce en tiempo real el transcurso del proceso.',
  
  titulo_BD:'Entrevista',
  BD:'Es uno de los momentos más importantes del proceso. Determinamos y analizamos puntos fuertes y débiles de cada uno de los candidatos pre-seleccionados.',
  
  titulo_GD:'Short List de candidatos',
  GD:'En este momento del proceso presentamos 3 candidatos seleccionados y ajustados al perfil. Los candidatos presentados no solo han sido pre-seleccionados, sino que también se han visionado trabajando dentro de su empresa.',
  
  titulo_FC:'Reclutamiento y análisis de hojas de vida ',
  FC:'Conjunto de procedimientos que tiene como propósito atraer candidatos para ocupar las vacantes solicitadas y así satisfacer el proceso de selección.',
  
  titulo_PC:'Pots Contratación',
  PC:'Evalúa los objetivos e indicadores de tus empleados a través de un modelo bilateral de evaluación inteligente basados en un método constructivo.',
};

export const txt_hv2 = {

  titulo_features:"Registrar Hoja de Vida",
  
  menu_inicio:"Inicio",

  menu_des_nos:"Nosotros",

  menu_portal:"Registrar HV",

  titulo_urlempresa:"Registrar Hoja de Vida",

  urlempresa:"https://user.dreamjobs.com.co/",

  chatbots:"Solicita retroalimentación de tu proceso de selección pasadas 72 horas.",

  kanban:"Recibe notificaciones en tiempo real de tu proceso de selección.",

  BD:'Revisa las ofertas que nuestro algoritmo te recomienda según tu perfil.',
  
  GD:'Adjunta documentos que las empresas te solicitan ¡Cuidemos juntos el medio.',
  
  FC:'Carga tu hoja de vida en el bolsillo y postúlate a las ofertas laborales desde cualquier lugar. ',
  
  PC:'Sube tu video de presentación para tener más probabilidad de ser elegido a un cargo.',
};






// WEBPACK FOOTER //
// ./src/app/texts/text.ts